/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { OneTimeProductOption } from "./OneTimeProductOption";
import type { SubscriptionProductOption } from "./SubscriptionProductOption";
import type { VisitOptionModel } from "./VisitOptionModel";

export interface VisitOptionsResponse {
  user_id: string;
  flow_name: string;
  product_options?: (SubscriptionProductOption | OneTimeProductOption)[];
  visit_options?: VisitOptionModel[];
}
